import { Attributes, List, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import CommissionRate from './CommissionRate';

@NeoModel
export default class CommissionType extends ModelBase {
    static typeName = "CommissionType";

    public commissionTypeId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Commission Type")
    public commissionTypeName: string = "";

    public commissionRates = new List(CommissionRate);

    // Client only properties / methods

    @Attributes.NoTracking()
    public isExpanded = false;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.commissionTypeName) {
            return "New commission type";
        } else {
            return this.commissionTypeName;
        }
    }
}